"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthTokenToJSON = exports.AuthTokenFromJSONTyped = exports.AuthTokenFromJSON = void 0;
function AuthTokenFromJSON(json) {
    return AuthTokenFromJSONTyped(json, false);
}
exports.AuthTokenFromJSON = AuthTokenFromJSON;
function AuthTokenFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'jwt': json['jwt'],
    };
}
exports.AuthTokenFromJSONTyped = AuthTokenFromJSONTyped;
function AuthTokenToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'jwt': value.jwt,
    };
}
exports.AuthTokenToJSON = AuthTokenToJSON;
//# sourceMappingURL=AuthToken.js.map